import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Image = styled.img`
  display: block;
  flex-shrink: 0;
  margin: auto 0;
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  width: ${props => props.width};
  @media (max-width: ${props => props.theme.deviceWidth.largePhone}) {
    order: ${p => p.order};
    width: 100%;
  }
`;

const CCImage = ({ className, image, width = '45%', order = 1 }) => (
  <Wrapper className={className} width={width} order={order}>
    {image && <Image src={image.src} alt={image.alt} />}
  </Wrapper>
);

CCImage.propTypes = {
  className: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string.isRequired
  }),
  width: PropTypes.string,
  order: PropTypes.number
};

export default CCImage;
